import { render, staticRenderFns } from "./TheModalSigla.vue?vue&type=template&id=42147569&"
import script from "./TheModalSigla.vue?vue&type=script&lang=js&"
export * from "./TheModalSigla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports